import ResetPassword, { IProps } from "./ResetPassword";

const ResetPasswordWrapper = (props: IProps) => {
	return <ResetPassword {...props} />;
};

export default ResetPasswordWrapper;
